import "./Policy.module.css";
import Header from "@/reusable_sections/Header";
import BookingTerms from "./sections/BookingTerms";
import TheFinePrint from "./sections/TheFinePrint";
import Footer from "@/reusable_sections/Footer";
export default function PolicyPage() {
  return <div>
      <Header />
      <BookingTerms />
      <TheFinePrint />
      <Footer />
    </div>;
}